import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import SendIcon from '@material-ui/icons/Send';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import OPTIONS_DATA from "../../imgComponents/icons/newicon.png"
const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);



function CUSTOMZEDMENUS(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };



  return (
    <div className='menu-table-new'>
      <img
        aria-controls="customized-menu"
        aria-haspopup="true"
        src={OPTIONS_DATA}
        variant="contained"
        className='icon-acciones-dt'
        color="green"
        alt=''
        title='Herramientas especiales'
        onClick={handleClick}
      >
      </img>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className="contenier-menu-icon"
      >
        {props.data.map((item, index) => (
          <StyledMenuItem key={index} onClick={item.onClick}>
            <ListItemIcon>{item.icon}</ListItemIcon>
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </div>
  );
}

export default CUSTOMZEDMENUS;